
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";

interface ProgramTableHeaderProps {
  allSelected: boolean;
  hasPrograms: boolean;
  onToggleSelectAll: () => void;
}

export function ProgramTableHeader({ 
  allSelected, 
  hasPrograms,
  onToggleSelectAll 
}: ProgramTableHeaderProps) {
  return (
    <TableHeader>
      <TableRow className="hover:bg-white/5 border-white/20">
        <TableHead className="w-[50px]">
          {hasPrograms && (
            <Checkbox 
              checked={allSelected}
              onCheckedChange={onToggleSelectAll}
            />
          )}
        </TableHead>
        <TableHead className="text-white/70">Program Name</TableHead>
        <TableHead className="text-white/70">Assigned Clients</TableHead>
        <TableHead className="text-white/70 w-[100px]"></TableHead>
      </TableRow>
    </TableHeader>
  );
}
